import { connect } from 'react-redux'

import { GroupOrderUniversalMenusReportsPage } from '@components/groupOrders/'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapDispatchToProps = () => {
  const { RestService, UIService, MarketService } = services
  const { LoadMarkets, RequestSendUniversalMenuConfigReport } = coordinators

  const { pResponseHeadquarters } = presenters.Api

  const loadHeadquarters = LoadMarkets({
    MarketService,
    RestService,
    pResponseHeadquarters,
  })

  const triggerReport = RequestSendUniversalMenuConfigReport({
    RestService,
    UIService,
    HandleError,
  })

  return {
    loadHeadquarters,
    triggerReport,
  }
}

export default connect(
  undefined,
  mapDispatchToProps,
)(GroupOrderUniversalMenusReportsPage)
